module.exports = __webpack_public_path__ + "static/media/marriage-6.0535796b.jpg";